const REASON_PT: Record<string, string> = {
  'Elb.RegistrationInProgress': 'Registro em andamento',
  'Elb.InitialHealthChecking': 'Verificação inicial',
  'Target.ResponseCodeMismatch': 'Código HTTP inesperado',
  'Target.Timeout': 'Timeout (sem resposta)',
  'Target.FailedHealthChecks': 'Health check falhou',
  'Target.HealthCheckDisabled': 'Health check desabilitado',
  'Target.NotInUse': 'Fora de uso',
  'Target.NotRegistered': 'Não registrado',
  'Target.DeregistrationInProgress': 'Removendo (draining)',
  'Target.IpUnusable': 'IP inutilizável',
  'Target.InvalidState': 'Estado inválido',
  'Elb.InternalError': 'Erro interno do ELB',
}

export function reasonLabel(reason: string): string {
  if (!reason) return ''
  return REASON_PT[reason] ?? reason
}

export const worstReasonLabel = reasonLabel
